// Action types for follow-up functionality
export const CONFIRMED_GET_FOLLOWUPS = "CONFIRMED_GET_FOLLOWUPS"
export const CONFIRMED_CREATE_FOLLOWUP_ACTION = "CONFIRMED_CREATE_FOLLOWUP_ACTION"
export const FOLLOWUP_LOADING = "FOLLOWUP_LOADING"
export const FOLLOWUP_ERROR = "FOLLOWUP_ERROR"
